import { FC } from 'react';
import { ParameterType, useParameterLabel } from '@edikk-edikk/country-frontend';
import modelDetailParameterCss from '../../assets/model-detail/model-detail-parameter.module.scss';

type PropsType = {
  value: string;
  type: ParameterType;
};

const Parameter: FC<PropsType> = ({
  value,
  type,
}) => {
  const label = useParameterLabel(type);

  return (
    <div className={modelDetailParameterCss.modelDetailParameter}>
      <div className={modelDetailParameterCss.modelDetailParameter__label}>
        {label}
      </div>
      <div className={modelDetailParameterCss.modelDetailParameter__value}>
        {value}
      </div>
    </div>
  );
};

export { Parameter };
